import { AxiosRequestConfig } from 'axios';
import { apiClient, IReqOptions } from 'common/clients/api.client.ts';
import { API_ENDPOINTS } from 'common/constants/api-endpoints.constants.ts';
import {
  IUserBillingFieldsRes,
  IUserProfileConfigReqData,
  IUserProfileConfigRes,
  IUserProfileDataRes,
  IUserPutBillingFieldsData,
  IUserPutBillingFieldsRes,
  IUserSessionsRes,
  IUserWalletsDataRes,
} from 'domains/user/interfaces/user.interfaces.ts';

export const getUserProfileDataService = async (): Promise<IUserProfileDataRes> => {
  const url = API_ENDPOINTS.USER.PROFILE;
  const res = await apiClient.get<IUserProfileDataRes>(url);

  return res.data;
};

export const getUserProfileConfigService = async ({
  reqOptions,
}: {
  reqOptions?: IReqOptions;
}): Promise<IUserProfileConfigRes> => {
  const url = API_ENDPOINTS.USER.CONFIG;
  const config = {
    ...reqOptions,
  } as AxiosRequestConfig;
  const res = await apiClient.get<IUserProfileConfigRes>(url, config);

  return res.data;
};

export const postUserProfileConfigService = async (data: IUserProfileConfigReqData): Promise<IUserProfileConfigRes> => {
  const url = API_ENDPOINTS.USER.CONFIG;
  const res = await apiClient.post<IUserProfileConfigRes>(url, data);

  return res.data;
};

export const getUserSessionsService = async (): Promise<IUserSessionsRes> => {
  const url = API_ENDPOINTS.USER.SESSIONS;
  const res = await apiClient.get<IUserSessionsRes>(url);

  return res.data;
};

export const getUserBillingFieldsService = async ({
  reqOptions,
} : {
  reqOptions?: IReqOptions;
}): Promise<IUserBillingFieldsRes> => {
  const url = API_ENDPOINTS.USER.BILLING_FIELDS;
  const config = {
    ...reqOptions,
  } as AxiosRequestConfig;
  const res = await apiClient.get<IUserBillingFieldsRes>(url, config);

  return res.data;
};

export const putUserBillingFieldsService = async (
  data: IUserPutBillingFieldsData
): Promise<IUserPutBillingFieldsRes> => {
  const url = API_ENDPOINTS.USER.BILLING_FIELDS;
  const res = await apiClient.put<IUserPutBillingFieldsRes>(url, data);

  return res.data;
};

export const getUserWalletsDataService = async ({
  reqOptions,
}: {
  reqOptions?: IReqOptions,
}): Promise<IUserWalletsDataRes> => {
  const url = API_ENDPOINTS.USER.WALLETS;
  const config = {
    ...reqOptions,
  } as AxiosRequestConfig;
  const res = await apiClient.get<IUserWalletsDataRes>(url, config);

  return res.data;
};
